'use client';

import {
  CachedWsrvImage,
  type CachedWsrvImageProps,
} from '@/components/ui/media/cached-wsrv-image';

export type TransparentAwareImageProps = Omit<CachedWsrvImageProps, 'src'> & {
  src: string;
};

export function TransparentAwareImage({
  src,
  showCheckerboard = true,
  transparencyFallbackSrc,
  ...props
}: TransparentAwareImageProps) {
  return (
    <CachedWsrvImage
      src={src}
      showCheckerboard={showCheckerboard}
      transparencyFallbackSrc={transparencyFallbackSrc ?? src}
      {...props}
    />
  );
}
